import axios from "axios";

/**
 * @typedef departuresAPI
 *
 * @property {stationsAPI} station Informacje o stacji
 * @property {departureDataAPI[]} departures Lista kursów na stacji (chronologicznie wg odjazdów)
 */

/**
 * @typedef departureDataAPI
 *
 * @property {string} agency_id ID operatora
 * @property {string} trip_id ID pociągu
 * @property {string} nr_poc Numer i nazwa pociągu
 * @property {string} linia Numer linii
 * @property {string} kierunek Kierunek jazdy
 * @property {string} przyjazd Godzina przyjazdu
 * @property {string} odjazd Godzina odjazdu
 * @property {boolean} isBUS Definiuje czy połączenie jest realizowane autobusem
 * @property {null|string} tabor Typ taboru (opcjonalnie)
 */

/**
 * Pobiera listę odjazdów ze stacji w danym dniu
 * @param {string} id
 * @param {string} data
 * @returns {Promise<departuresAPI>}
 */
export default function getDepartures(id, data) {
    return axios.get(`/api/departures/${id}/${data}`)
        .then(resp => resp.data);
}
